import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Lock } from 'lucide-react';

import { useCurrentUserRole } from '@/lib/team';

// Sprint Control — layout owner-only. Mismo patrón que /compliance: el
// gate vive acá para que toda la sub-app herede protección sin repetirla
// en cada child. El backend además rechaza con 403 si el caller no tiene
// control.access (defense-in-depth) — esta UI guard es solo cosmética.
//
// Nota: useCurrentUserRole hace loading-as-viewer (mínimo privilegio),
// así que durante el primer fetch del role el user ve el bloque "Acceso
// restringido" por unos ms — aceptable, mejor que mostrar contenido
// sensible que después se oculta.

export const Route = createFileRoute('/_app/control')({
  component: ControlLayout,
});

function ControlLayout() {
  const role = useCurrentUserRole();

  if (role !== 'owner') {
    return (
      <div
        className="mx-auto flex max-w-md flex-col items-center justify-center gap-3 rounded-lg border py-16 text-center"
        style={{ borderColor: 'var(--color-border)' }}
      >
        <Lock className="h-6 w-6" style={{ color: 'var(--color-fg-subtle)' }} aria-hidden />
        <h2 className="text-base font-semibold" style={{ color: 'var(--color-fg)' }}>
          Acceso restringido
        </h2>
        <p className="text-sm" style={{ color: 'var(--color-fg-muted)' }}>
          El módulo Control es exclusivo del owner de la organización.
        </p>
      </div>
    );
  }

  return <Outlet />;
}
